var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconKeyword(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#080A47",
    d: "M0 0h40v40H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC947",
    d: "M21.333 19.333 0 0v40l21.333-20.667z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#45C9C1",
    d: "M19.333 19.333 40 0v40L19.333 19.333z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F480D4",
    d: "M20.667 19.333 40 40H0l20.667-20.667z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconKeyword);
export default __webpack_public_path__ + "static/media/icon-keyword.52ca0879bbb20af17cc4e4ebcdda4b45.svg";
export { ForwardRef as ReactComponent };